import viewIcon from '../../assets/icons/view-icon.svg';
import './DatasetTable.scss';

interface Card {
    label: string;
    value: string | number;
    route?: string;
}

interface DatasetTablesProps {
    onScrollToTables: () => void;
    cardData: Card[];
    onCardClick?: (cardLabel: string, route?: string) => void;
}

function DatasetTables({ onScrollToTables, cardData, onCardClick }: DatasetTablesProps) {

    return (
        <div className="dataset-tables">
            <div className="dataset-tables__wrap row">
                {cardData.map((card, index) => {
                    const isConsumer360 = card.label === "Consumer 360 Profiles";
                    return (
                        <div
                            className="dataset-tables__card-wrap col-md-4"
                            key={index}
                        >
                            <div
                                className={`dataset-tables__card ${isConsumer360 ? 'no-hover' : ''}`}
                                onClick={() => {
                                    if (isConsumer360) return;
                                    if (card.label === "Attributes Tables") {
                                        onScrollToTables();
                                    } else if (card.route && onCardClick) {
                                        onCardClick(card.label, card.route);
                                    }
                                }}
                                style={{ cursor: isConsumer360 ? "default" : "pointer" }}
                            >
                                <div>
                                    <div className="dataset-tables__card__label">{card.label}:</div>
                                    <div className="dataset-tables__card__value">{card.value}</div>
                                </div>
                                {!isConsumer360 && (
                                    <div className="dataset-tables__link-wrap">
                                        <div className="dataset-tables__link-wrap__link">View</div>
                                        <img src={viewIcon} alt="view" />
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}

            </div>
        </div>
    );
}


export default DatasetTables;
